import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import authReducer from "./authSlice";
import layoutReducer from "./layoutSlice";
import storage from "redux-persist/lib/storage";

import { Reducer } from "redux";
import { FLUSH, PAUSE, PERSIST, persistReducer, PURGE, REGISTER, REHYDRATE } from "redux-persist";

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["clientApi", "_persist"],
};

export const combineReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  layout: layoutReducer,
});

export const rootReducers: Reducer<RootState> = (state, action) => {
  // this is to reset the state to default when user logs out
  if (action.type === "auth/logout") {
    state = {} as RootState;
  }
  return combineReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducers);

const store = configureStore({
  devTools: true,
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Derived from the combined reducer rather than store.getState() so that
// rootReducers below can be annotated with RootState without the two
// referencing each other in a cycle.
export type RootState = ReturnType<typeof combineReducer>;
export type AppDispatch = typeof store.dispatch;

export default store;
